import { apiFetch } from '@m/utils/http';

export const FeeService = {
  getTransactionFeePlans: () => apiFetch('/admin/transaction-fees'),

  getTransactionFeesForSite: ({ siteId }: { siteId: number }) =>
    apiFetch(`/admin/transaction-fees/fees-for-site?siteId=${siteId}`),

  enableTransactionFeeForSite: ({ siteId, feeId }: { feeId: number; siteId: number }) =>
    apiFetch(`/admin/transaction-fees/${feeId}?siteId=${siteId}`, { method: 'POST' }),

  disableTransactionFeeForSite: ({ siteFeeId }: { siteFeeId: number }) =>
    apiFetch(`/admin/transaction-fees/remove-fee-from-site?siteFeeId=${siteFeeId}`, {
      method: 'DELETE',
    }),

  assignTransactionFeeForSite: ({
    siteId,
    fees,
  }: {
    fees: { transactionFeePlanId: number; untilMinutesElapsed?: number | null }[];
    siteId: number;
  }) =>
    apiFetch(`/admin/transaction-fees/update-zone-fee`, {
      method: 'POST',
      body: fees.map((data) => ({ ...data, siteId })),
      params: { siteId },
    }),

  getSubscriptionFeePlans: () => apiFetch('/admin/subscription-fees'),

  getSubscriptionFeesForSite: ({ siteId }: { siteId: number }) =>
    apiFetch(`/admin/subscription-fees/fees-for-site?siteId=${siteId}`),

  enableSubscriptionFeeForSite: ({ siteId, feeId }: { feeId: number; siteId: number }) =>
    apiFetch(`/admin/subscription-fees/${feeId}?siteId=${siteId}`, { method: 'POST' }),

  disableSubscriptionFeeForSite: ({ siteFeeId }: { siteFeeId: number }) =>
    apiFetch(`/admin/subscription-fees/remove-fee-from-site?siteFeeId=${siteFeeId}`, {
      method: 'DELETE',
    }),

  createSubscriptionFeePlan: (body: {
    flatAmount?: number;
    maximum: number;
    minimum: number;
    percent?: number;
  }) =>
    apiFetch('/admin/subscription-fees', {
      method: 'POST',
      body,
    }),

  getSubscriptionFeeOverrideConfig: ({ subscriptionId }: { subscriptionId: number }) =>
    apiFetch(`/v2/subscriptions/${subscriptionId}/fees/override`, {
      method: 'GET',
    }),

  updateSubscriptionFeeOverrideConfig: ({
    subscriptionId,
    enabled,
  }: {
    enabled: boolean;
    subscriptionId: number;
  }) =>
    apiFetch(`/v2/subscriptions/${subscriptionId}/fees/override`, {
      method: 'POST',
      body: { enabled },
    }),

  createTransactionFeePlan: (body: { maximum: number; minimum: number; percent?: number }) =>
    apiFetch('/admin/transaction-fees', {
      method: 'POST',
      body,
    }),
};
